<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>

    <v-card>
      <v-card-title>Nuova prenotazione</v-card-title>

      <v-card-text>
        <v-autocomplete
          v-model="iva_sel"
          :items="clienti"
          item-text="nome"
          item-value="iva"
          label="Cliente"
          outlined
          dense
          :filter="filtra_clienti"
          clearable
          class="mt-2"
        >
          <template #item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.nome }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.iva }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>

        <v-textarea
          v-model="commento"
          label="Commento iniziale (opzionale)"
          outlined
          dense
          rows="3"
          auto-grow
        />

        <v-switch
          v-model="usa_data_ritiro"
          label="Imposta data ritiro prevista"
          dense
          class="mt-1 mb-0"
          hide-details
        />
        <template v-if="usa_data_ritiro">
          <v-row no-gutters class="mt-3">
            <v-col cols="7" class="pr-2">
              <v-dialog
                ref="dialog_nd"
                v-model="modal_nuova_date"
                :return-value.sync="nuova_date"
                persistent
                width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="nuova_date_label"
                    label="Data"
                    prepend-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="nuova_date" scrollable locale="it-it" :min="oggi">
                  <v-spacer />
                  <v-btn text color="primary" @click="modal_nuova_date = false">Annulla</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog_nd.save(nuova_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="5">
              <v-dialog ref="dialog_nt" v-model="modal_nuova_time" persistent width="290px">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="nuova_time"
                    label="Ora"
                    prepend-icon="mdi-clock-outline"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="modal_nuova_time"
                  v-model="nuova_time"
                  full-width
                  format="24hr"
                  @click:hour="chiudi_ora_nuova"
                >
                  <v-spacer />
                  <v-btn text color="primary" @click="modal_nuova_time = false">Annulla</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </template>

        <v-alert v-if="error" type="error" dense text class="mt-2">
          {{ error }}
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="chiudi">Annulla</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!iva_sel"
          @click="crea"
        >
          Crea
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  name: "NuovaPrenotazioneDialog",

  data() {
    return {
      dialog: false,
      iva_sel: null,
      commento: "",
      usa_data_ritiro: false,
      nuova_date: "",
      nuova_time: "09:00",
      modal_nuova_date: false,
      modal_nuova_time: false,
      loading: false,
      error: null,
    };
  },

  computed: {
    clienti() {
      return this.$store.getters.get_clienti.filter((c) => !c.isAdmin);
    },

    nuova_date_label() {
      if (!this.nuova_date) return "";
      moment.locale("it");
      return moment(this.nuova_date).format("dddd D MMMM");
    },

    oggi() {
      return moment().format("YYYY-MM-DD");
    },
  },

  methods: {
    filtra_clienti(item, queryText) {
      const q = queryText.toLowerCase();
      return (
        item.nome.toLowerCase().includes(q) ||
        item.iva.includes(q)
      );
    },

    async crea() {
      this.loading = true;
      this.error = null;
      try {
        const payload = { iva: this.iva_sel, commento: this.commento };
        if (this.usa_data_ritiro && this.nuova_date && this.nuova_time) {
          payload.data_ritiro_ts = parseInt(moment(this.nuova_date + " " + this.nuova_time).format("X"));
        }
        const pren = await this.$store.dispatch("prenotazioni/crea", payload);
        this.$emit("creata", pren);
        this.chiudi();
      } catch (e) {
        this.error =
          e?.response?.data?.error === "cliente_non_trovato"
            ? "Cliente non trovato nel database."
            : "Errore durante la creazione. Riprova.";
      } finally {
        this.loading = false;
      }
    },

    chiudi() {
      this.dialog = false;
      this.iva_sel = null;
      this.commento = "";
      this.usa_data_ritiro = false;
      this.nuova_date = "";
      this.nuova_time = "09:00";
      this.error = null;
    },

    chiudi_ora_nuova(v) {
      this.nuova_time = (v < 10 ? "0" + v : v) + ":00";
      this.modal_nuova_time = false;
    },
  },
};
</script>
